import RegistrationPage from './components/RegistrationPage';
import { RegistrationReviewProvider } from './RegistrationReviewProvider';

export default function RegistrationReviewPage() {
  return (
    <RegistrationReviewProvider>
      <RegistrationPage />
    </RegistrationReviewProvider>
  );
}
